import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, inject } from "vue";
import {
  ModelThrowComponentsTab,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'router-tab-button',
  props: {
  val: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>,
  },
  currentTab: {
    default: null,
    type: [String, Number] as PropType<ModelThrowComponentsTab>,
  },
  label: {
    default: null,
    type: String as PropType<string | null>,
  },
},
  setup(__props) {

const props = __props;



const onClickTab: ((activeTab: ModelThrowComponentsTab) => number) | undefined =
  inject("injectFromTab");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmButton), {
    class: "router-tab-button",
    "is-rounded": "",
    size: _unref(TirPmButtonSizeEnum).Small,
    variant: 
      __props.currentTab === __props.val
        ? _unref(TirPmButtonVariantEnum).PrimaryState
        : _unref(TirPmButtonVariantEnum).TertiaryState
    ,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onClickTab)(__props.val)))
  }, {
    leftSlot: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    default: _withCtx(() => [
      _createTextVNode(" " + _toDisplayString(props.label), 1)
    ]),
    _: 3
  }, 8, ["size", "variant"]))
}
}

})